<template>
  <form class="form__group">
    <div class="gl-forms__container">
      <div class="gl-forms__title">
        {{ $t('admins.info') }}
      </div>
      <div class="gl-grid-form">
        <div class="form__group col-1">
          <gl-input
            id="admin.email"
            v-model.trim="$v.updatedAdmin.email.$model"
            v-skeletor:onChange="setValue"
            v-permission-guard="'views.admins.edit'"
            :type="'email'"
            :label="$t('account.forms.email')"
            :placeholder="$t('account.forms.email')"
            :mandatory="true"
            :value="$v.updatedAdmin.email.$model"
            :readonly="action === 'edit'"
            :errormessage="
              !$v.updatedAdmin.email.required && $v.updatedAdmin.email.$model !== null
                ? $t('account.errors.fieldRequired')
                : $v.updatedAdmin.email.$error || $v.updatedAdmin.email.$invalid
                ? errorMessages.email
                : null
            "
          >
          </gl-input>
        </div>
        <div class="form__group col-2">
          <gl-input
            id="admin.name"
            v-model.trim="$v.updatedAdmin.name.$model"
            v-skeletor:onChange="setValue"
            v-permission-guard="'views.admins.edit'"
            :type="'text'"
            :label="$t('account.forms.name')"
            :placeholder="$t('account.forms.name')"
            :mandatory="true"
            :value="$v.updatedAdmin.name.$model"
            :errormessage="
              !$v.updatedAdmin.name.required && $v.updatedAdmin.name.$model !== null
                ? $t('account.errors.fieldRequired')
                : $v.updatedAdmin.name.$error || !$v.updatedAdmin.name.isMaxLength
                ? errorMessages.name
                : null
            "
          >
          </gl-input>
        </div>
        <div class="form__group col-2">
          <gl-input
            id="admin.surname"
            v-model.trim="$v.updatedAdmin.surname.$model"
            v-skeletor:onChange="setValue"
            v-permission-guard="'views.admins.edit'"
            :type="'text'"
            :label="$t('account.forms.surname')"
            :placeholder="$t('account.forms.surname')"
            :value="$v.updatedAdmin.surname.$model"
          >
          </gl-input>
        </div>
        <div class="form__group col-2-fullrow">
          <gl-input
            id="admin.pid"
            v-model.trim="$v.updatedAdmin.pid.$model"
            v-skeletor:onChange="setValue"
            v-permission-guard="'views.admins.edit'"
            :type="'text'"
            :label="$t('account.forms.dni')"
            :placeholder="$t('account.forms.dni')"
            :value="$v.updatedAdmin.pid.$model"
          >
          </gl-input>
        </div>
        <div class="form__group col-2-fullrow">
          <gl-input
            id="admin.phone"
            v-model.trim="$v.updatedAdmin.phone.$model"
            v-skeletor:onChange="setValue"
            v-permission-guard="'views.admins.edit'"
            :type="'text'"
            :label="$t('account.forms.phone')"
            :placeholder="$t('account.forms.phone')"
            :value="$v.updatedAdmin.phone.$model"
          >
          </gl-input>
        </div>
        <div class="form__group col-2-fullrow">
          <gl-select
            id="admin.lang"
            v-permission-guard="'views.admins.edit'"
            v-skeletor:onChange="setValue"
            :label="$t('account.forms.lang')"
            :placeholder="$t('account.forms.lang')"
            :options="JSON.stringify(getLanguages)"
            :mandatory="true"
            :value="JSON.stringify($v.updatedAdmin.lang.$model)"
            :separator="true"
            :errormessage="$v.updatedAdmin.lang.$error ? $t('account.errors.fieldRequired') : null"
          >
          </gl-select>
        </div>
        <div class="form__group col-2-fullrow">
          <gl-select
            id="admin.countryId"
            v-permission-guard="'views.admins.edit'"
            v-skeletor:onChange="setValue"
            :label="$t('account.forms.country')"
            :placeholder="$t('account.forms.country')"
            :options="JSON.stringify(countries)"
            :mandatory="true"
            :value="JSON.stringify($v.updatedAdmin.countryId.$model)"
            :separator="true"
            :errormessage="
              $v.updatedAdmin.countryId.$error ? $t('account.errors.fieldRequired') : null
            "
          >
          </gl-select>
        </div>
        <div class="form__group col-2">
          <gl-select
            id="admin.timezone"
            v-permission-guard="'views.admins.edit'"
            v-skeletor:onChange="setValue"
            :label="$t('account.forms.timezone')"
            :placeholder="$t('account.forms.timezone')"
            :options="JSON.stringify(getTimezones(updatedAdmin.countryId))"
            :mandatory="true"
            :disabled="!updatedAdmin.countryId"
            :value="JSON.stringify($v.updatedAdmin.timezone.$model)"
            :separator="true"
            :errormessage="
              $v.updatedAdmin.countryId.$error ? $t('account.errors.fieldRequired') : null
            "
          >
          </gl-select>
        </div>
        <div class="form__group col-2-fullrow">
          <!-- TODO: Change the disabled attribute when the admins section is decided in ADMIN -->
          <gl-select
            id="admin.role"
            v-permission-guard="'views.admins.edit'"
            v-skeletor:onChange="setValue"
            :label="$t('account.forms.rol')"
            :placeholder="$t('account.forms.rol')"
            :options="JSON.stringify(getRoles)"
            :mandatory="true"
            :disabled="action === 'edit'"
            :value="JSON.stringify($v.updatedAdmin.role.$model)"
            :separator="true"
            :errormessage="$v.updatedAdmin.role.$error ? $t('account.errors.fieldRequired') : null"
          >
          </gl-select>
        </div>
        <div class="col-2-fullrow">
          <div class="account__block--checkbox">
            <gl-checkbox
              id="admin.blocked"
              v-permission-guard="'views.admins.edit'"
              v-skeletor:onChange="setValue"
              :label="$t('admins.blockAdmin')"
              :placeholder="$t('admins.blockAdmin')"
              :checked="updatedAdmin.blocked"
              :small="true"
            >
            </gl-checkbox>
          </div>
          <div class="account__block--checkbox">
            <gl-checkbox
              id="admin.isCreator"
              v-permission-guard="'views.admins.edit'"
              v-skeletor:onChange="setValue"
              :label="$t('admins.accessEditor')"
              :checked="updatedAdmin.isCreator"
              :readonly="updatedAdmin.role === 'creator'"
              :small="true"
            >
            </gl-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- Notifications configuration -->
    <template v-if="shouldShowNotificationsCfg">
      <div class="gl-forms__container">
        <div class="gl-forms__title">
          {{ $t('admins.notifications') }}
        </div>

        <!-- na2 -->
        <template v-if="shouldShowNa2Cfg">
          <div class="form__row">
            <div class="account__block--checkbox">
              <gl-checkbox
                id="admin.notifications.na2.enabled"
                v-permission-guard="'views.admins.edit'"
                v-skeletor:onChange="setNotifications"
                :label="$t('admins.mailResumeActivity')"
                :placeholder="$t('admins.mailResumeActivity')"
                :tooltip="$t('admins.mailResumeActivityTooltip')"
                :checked="updatedAdmin.notificationsCfg.na2.enabled"
                :small="true"
              >
              </gl-checkbox>
            </div>
            <div class="form__group">
              <gl-select
                id="admin.notifications.na2.weekPeriodicity"
                v-permission-guard="'views.admins.edit'"
                v-skeletor:onChange="setNotifications"
                :label="$t('admins.mailFrequencyResumeActivity')"
                :placeholder="$t('admins.mailFrequencyResumeActivity')"
                :options="JSON.stringify(weeks)"
                :mandatory="true"
                :value="JSON.stringify(updatedAdmin.notificationsCfg.na2.weekPeriodicity)"
                :separator="true"
                :disabled="updatedAdmin.notificationsCfg.na2.enabled !== true"
                :errormessage="
                  !updatedAdmin.notificationsCfg ? $t('account.errors.fieldRequired') : null
                "
              >
              </gl-select>
            </div>
          </div>
        </template>
      </div>
    </template>

    <!-- Form buttons -->
    <div class="gl-grid-form__buttons margin-auto">
      <gl-button
        v-if="action === 'create'"
        id="admin.btn-cancel"
        v-permission-guard="'views.admins.add'"
        color-secondary
        class="btn"
        :type="'button'"
        :text="$t('account.forms.cancel')"
        @onClick="$router.push({ name: 'admins' })"
      ></gl-button>
      <gl-button
        v-if="action === 'create'"
        id="admin.btn-add"
        v-permission-guard="'views.admins.add'"
        color-primary
        :type="'submit'"
        :text="$t('admins.addAdmin')"
        :disabled="$v.$invalid || !dirtyFields"
        @onClick="saveAdmin(updatedAdmin)"
      ></gl-button>
      <gl-button
        v-if="action === 'edit'"
        id="admin.btn-save"
        v-permission-guard="'views.admins.edit'"
        color-primary
        :type="'submit'"
        :text="$t('account.forms.saveChanges')"
        :disabled="$v.$invalid || !dirtyFields"
        @onClick.prevent="saveAdmin(updatedAdmin)"
      ></gl-button>
    </div>

    <!-- Error modal -->
    <AdminLimitModal v-if="showLimitError" />
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AdminLimitModal from '@/components/Modals/AdminLimitModal.vue';
import { required, email } from 'vuelidate/lib/validators';
import { formatIds } from '../../utils/functions.js';

export default {
  name: 'AdminEditForm',
  components: {
    AdminLimitModal
  },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      adminId: null,
      updatedAdmin: {
        name: null,
        surname: '',
        email: null,
        pid: '',
        phone: '',
        lang: [],
        timezone: '',
        role: '',
        blocked: false,
        isCreator: false,
        notificationsCfg: {
          na2: {
            enabled: true,
            weekPeriodicity: 1
          }
        }
      },
      weeks: [
        { key: 1, value: this.$i18n.t('account.forms.weeks.1') },
        { key: 2, value: this.$i18n.t('account.forms.weeks.2') },
        { key: 4, value: this.$i18n.t('account.forms.weeks.4') }
      ],
      errorMessages: {},
      dirtyFields: false
    };
  },
  computed: {
    ...mapState({
      profile: (state) => state.profile.profileData,
      admin: (state) => state.admins.admin,
      showLimitError: (state) => state.admins.showLimitError,
      countries: (state) => state.global.countries,
      shouldShowNotificationsCfg() {
        return this.shouldShowNa2Cfg;
      },
      shouldShowNa2Cfg() {
        return ['clientAdmin', 'dachAdmin', 'hr', 'distributor', 'expert'].includes(
          this.updatedAdmin.role
        );
      }
    }),
    ...mapGetters(['getTimezones', 'getRoles', 'getLanguages'])
  },
  watch: {
    admin(newValue) {
      this.updatedAdmin = { ...this.updatedAdmin, ...newValue };
    }
  },
  created() {
    this.adminId = this.$route.params.id;
    this.updatedAdmin = {
      ...this.updatedAdmin,
      countryId: this.profile.countryId,
      timezone: this.getTimezones(this.profile.countryId)[0]['key'],
      ...this.admin
    };
  },
  methods: {
    setValue(field, value, dirty) {
      this.setForm(formatIds(field), value);
      // timezone
      this.updateTimezone(formatIds(field), value);
      // creator
      this.setCreatorRole(value);

      this.setDirtyField(dirty);
    },
    setCreatorRole(role) {
      if (role === 'creator') {
        this.setForm('isCreator', true);
      }
    },
    setForm(attr, value) {
      this.$set(this.updatedAdmin, attr, value);
    },
    setDirtyField(dirty) {
      this.dirtyFields = dirty;
    },
    updateTimezone(attr, countryId) {
      if (attr === 'countryId') {
        const timezones = this.getTimezones(countryId);
        this.setForm('timezone', timezones[0].key);
      }
    },
    setNotifications(attr, value, dirty) {
      if (formatIds(attr) === 'weekPeriodicity') {
        this.$set(this.updatedAdmin.notificationsCfg.na2, 'weekPeriodicity', Number(value));
      }

      if (formatIds(attr) === 'enabled') {
        this.$set(this.updatedAdmin.notificationsCfg.na2, 'enabled', value);
      }

      this.setDirtyField(dirty);
    },
    saveAdmin(admin) {
      if (admin) {
        this.$emit('save', admin);
      }
    }
  },
  validations: {
    updatedAdmin: {
      name: {
        required,
        isMaxLength(value) {
          if (value && value.length < 3) {
            this.$set(this.errorMessages, 'name', this.$t('account.errors.maxLengthName'));
            return false;
          }
          return true;
        }
      },
      surname: {},
      email: {
        required,
        email,
        isEmail(value) {
          if (value && !this.$v.updatedAdmin.email.email) {
            this.$set(this.errorMessages, 'email', this.$t('account.errors.invalidEmail'));
            return false;
          }
          return true;
        }
      },
      pid: {},
      phone: {},
      timezone: { required },
      lang: { required },
      countryId: { required },
      role: { required }
    }
  }
};
</script>
